import React from 'react';
import { addDays, format, isSameDay, startOfDay } from 'date-fns';

export default function getClickCollectFormattedTime(params) {
  const {
    time,
    bold = true,
    timeOnly,
    dayOnly,
  } = params;

  const collectDay = startOfDay(time);
  const timeNowTomorrow = addDays(startOfDay(new Date()), 1);

  const formatted24HourTime = format(time, 'HH:mm');
  const formatToHour = format(time, 'h:mma');

  const day = isSameDay(collectDay, timeNowTomorrow) ? 'tomorrow' : format(time, 'dddd');

  if (timeOnly) {
    return formatToHour;
  }

  if (dayOnly || formatted24HourTime === '00:00') {
    return bold ? <>from <strong>{day}</strong></> : `from ${day}`;
  }

  return bold ? <>from <strong>{formatToHour} {day}</strong></> : `from ${formatToHour} ${day}`;
}
